import { render } from "./VueScrollingTable.vue?vue&type=template&id=7fc0bef9"
import script from "./VueScrollingTable.vue?vue&type=script&lang=js"
export * from "./VueScrollingTable.vue?vue&type=script&lang=js"

import "./VueScrollingTable.vue?vue&type=style&index=0&id=7fc0bef9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__